import React, { FC } from 'react';
import { Badge, Box, BoxProps, Heading, List, Stack, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from './ui/accordion';

const faqKeys = [
  { index: 0, tag: 'App' },
  { index: 1, tag: 'Security' },
  { index: 2, tag: 'Implementation' },
  { index: 3, tag: 'Implementation' },
  { index: 4, tag: 'Customization' },
  { index: 5, tag: 'Compliance' },
  { index: 6, tag: 'Features' },
  { index: 7, tag: 'Compliance' },
  { index: 8, tag: 'Reporting' },
  { index: 9, tag: 'App' },
  { index: 10, tag: 'App' },
  { index: 11, tag: 'Support' },
  { index: 12, tag: 'Features' },
  { index: 13, tag: 'App' },
  { index: 14, tag: 'Security' }
] as const;

interface FAQsProps extends BoxProps {}

const FAQs: FC<FAQsProps> = (props) => {
  const { t } = useTranslation('landing');
  return (
    <Box {...props}>
      <VStack gap={6} mx='auto' px={{ base: '6', md: '10' }} mb={10} alignItems='start'>
        <Heading as='h2' size='6xl' fontWeight='normal'>
          <Text as='span' color='accent' fontWeight='extrabold'>
            {t('faq.title1')}
          </Text>{' '}
          <Text as='span' color='accent-alt' fontWeight='extrabold'>
            {t('faq.title2')}
          </Text>
          <Text as='span' color='accent' fontWeight='extrabold'>
            .
          </Text>
        </Heading>
        <Text color='subtle' mt='5' fontSize='xl'>
          {t('faq.subtitle')}
        </Text>
      </VStack>

      <AccordionRoot px={{ base: '6', md: '10' }}>
        {faqKeys.map((faq) => (
          <AccordionItem py='4' key={faq.index} value={`faq-${faq.index}`}>
            <AccordionItemTrigger gap={4} borderRadius='md'>
              <Text as='h2' fontWeight='semibold' textStyle='xl' textAlign='left'>
                {t(`faq.${faq.index}.q`)}
              </Text>
              <Badge
                variant='subtle'
                colorPalette='brand'
                color='brand.800'
                _light={{ bgColor: 'red.100' }}
                _dark={{ bgColor: 'secondary.200', color: 'gray.900' }}
              >
                {faq.tag}
              </Badge>
            </AccordionItemTrigger>
            <AccordionItemContent>
              <Stack gap={{ base: '6', md: '8' }}>
                <Stack gap={{ base: '4', md: '5' }}>
                  {faq.index === 11 ? (
                    <>
                      <Text as='span'>{t('faq.11.a.intro')}</Text>
                      <List.Root py={4}>
                        <List.Item>{t('faq.11.a.item1')}</List.Item>
                        <List.Item>{t('faq.11.a.item2')}</List.Item>
                        <List.Item>{t('faq.11.a.item3')}</List.Item>
                      </List.Root>
                    </>
                  ) : (
                    <Text color='fg.muted'>{t(`faq.${faq.index}.a`)}</Text>
                  )}
                </Stack>
              </Stack>
            </AccordionItemContent>
          </AccordionItem>
        ))}
      </AccordionRoot>
    </Box>
  );
};

export default FAQs;
